/* @flow */

import React from 'react';
import { Segment, Icon, Image, Button } from 'semantic-ui-react';
import { NATURAL_HEIGHT, NATURAL_WIDTH } from 'src/helpers/individual-attraction.helper';
import { CUSTOMIZABLE_IMAGES } from 'src/routes/manage/EventInformation/confirmationEmail/constants';

import Uploader from './uploader';
import ImageCropper from './image-cropper';
import styles from './styles.css';

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.openUploadcare = this.openUploadcare.bind(this);
    this.handleUploadImage = this.handleUploadImage.bind(this);
    this.clearImage = this.clearImage.bind(this);
    this.handleOpenCrop = this.handleOpenCrop.bind(this);

    const croppedSize = (() => {
      switch (this.props.id) {
        case 'uploader-social':
          return {
            aspect: 1 / 1,
            width: 300,
            height: 300,
          };
        case 'uploader-attraction':
          return {
            aspect: NATURAL_WIDTH / NATURAL_HEIGHT,
            width: NATURAL_WIDTH,
            height: NATURAL_HEIGHT,
          };
        case 'uploader-customizable-email':
          return {
            aspect: CUSTOMIZABLE_IMAGES.WIDTH / CUSTOMIZABLE_IMAGES.WIDTH,
            width: 100,
            unit: '%',
          };
        default:
          return {
            aspect: 2.5 / 1,
            width: 2220,
            height: 888,
          };
      }
    })();

    this.state = {
      imageUrl: props.image ? props.image.imageUrl : undefined,
      imageWidth: undefined,
      imageHeight: undefined,
      modalOpen: false,
      uploadId: props.image ? props.image.uploadId : undefined,
      is_gif: undefined,
      cropCanvas: undefined,
      croppedImage: undefined,
      cropSelector: {
        unit: 'px', // default, can be 'px' or '%'
        x: 0,
        y: 0,
        ...croppedSize,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.image !== this.props.image) {
      this.setState({
        imageUrl: this.props.image?.imageUrl ? this.props.image.imageUrl : null,
        uploadId: this.props.image?.uploadId ? this.props.image.uploadId : null,
      });
    }
  }

  handleUploadImage(info) {
    const data = { uploadId: info.uuid, is_gif: false, imageUrl: info.cdnUrl };
    this.setState(data, () => this.handleUpload());
  }

  handleOpenCrop() {
    this.setState({ modalOpen: true });
  }

  handleCloseCrop() {
    this.setState({ modalOpen: false });
  }

  handleCrop() {
    const { state } = this;
    const widthRatio = state.imageWidth / state.cropCanvas.width;
    const heightRatio = state.imageHeight / state.cropCanvas.height;
    const cropX = Math.round(state.cropSelector.x * widthRatio);
    const cropY = Math.round(state.cropSelector.y * heightRatio);
    const cropWidth = Math.round(state.cropSelector.width * widthRatio);
    const cropHeight = Math.round(state.cropSelector.height * heightRatio);

    const croppedImage = {
      x: cropX,
      y: cropY,
      width: cropWidth,
      height: cropHeight,
    };
    this.setState({ croppedImage }, () => this.handleUpload());
  }

  handleUpload() {
    this.props.handleUpload(this.state);
    this.uploader.widget.value('');
  }

  emptyImage() {
    return (
      <Segment
        className={`
          ${styles.emptySegment}
          ${this.props.index === 0 ? styles.emptySquare : ''}
          ${this.props.customSize}
        `}
        onClick={this.openUploadcare}
      >
        <Image />
        <span className={this.props.uploadTextClass || styles.uploadText}>
          {this.props.addButton && <Button>{this.props.addButton}</Button>}
          <div className={styles.uploadTextHeader}>{this.props.header}</div>
          <div className={styles.uploadTextBody}>{this.props.body}</div>
        </span>
      </Segment>
    );
  }

  openUploadcare() {
    document.querySelectorAll('.uploadcare--widget__button_type_open')[this.props.index].click();
  }

  clearImage() {
    this.props.clearImage();
    this.uploader.widget.value('');
  }

  deleteIcon() {
    return <Icon className="universe-delete" bordered inverted link color="black" onClick={this.clearImage} />;
  }

  cropIcon() {
    return (
      <Icon
        className="universe-crop"
        bordered
        inverted
        link
        color="black"
        onClick={this.handleOpenCrop}
      />
    );
  }

  render() {
    let imageBeforeCrop;
    let imageAfterCrop;
    let cropUrl;
    const { props } = this;

    if (props.image) {
      // Image must be resized before cropping because images served from our API are resized to 1200px
      imageBeforeCrop = `${props.image.imageUrl}-/resize/1200x/`;
      if (props.image.croppedImage) {
        const { croppedImage } = props.image;
        cropUrl =
          croppedImage.width && croppedImage.height
            ? `-/crop/${croppedImage.width}x${croppedImage.height}/${croppedImage.x},${croppedImage.y}/`
            : '';
        imageAfterCrop = `${imageBeforeCrop + cropUrl}`;
      }
    }

    return (
      <div style={{ minHeight: '210px' }}>
        {props.image ? (
          <Segment style={{ padding: 0, border: 0 }}>
            <div
              className={`
                ${styles.imageContainer}
                ${props.index === 0 ? styles.imageContainerSquare : styles.imageContainerRectangle}
                ${props.customSize}
              `}
            >
              <Image rounded centered src={imageAfterCrop || imageBeforeCrop} />
              <div className={styles.imageOverlayContainer}>
                {props.canCrop && this.cropIcon()}
                {this.deleteIcon()}
              </div>
              {props.changeButton && (
                <Button className={styles.changePhotoButton} onClick={this.openUploadcare}>
                  {props.changeButton}
                </Button>
              )}
            </div>
          </Segment>
        ) : (
          this.emptyImage()
        )}
        <Uploader
          id="file"
          name="file"
          data-crop="disabled"
          data-preview-step={props.preview || 'false'}
          onUploadComplete={info => this.handleUploadImage(info)}
          ref={uploader => {
            this.uploader = uploader;
          }}
        />

        {props.image && (
          <ImageCropper
            resizedImage={imageBeforeCrop}
            modalOpen={this.state.modalOpen}
            cropSelector={this.state.cropSelector}
            onImageLoaded={image =>
              this.setState({
                imageWidth: image.naturalWidth,
                imageHeight: image.naturalHeight,
                cropCanvas: {
                  width: image.width,
                  height: image.height,
                },
              })
            }
            onHandleCropSelector={crop => this.setState({ cropSelector: crop })}
            onHandleClose={() => this.handleCloseCrop()}
            onHandleCrop={() => {
              this.handleCrop();
              this.handleCloseCrop();
            }}
          />
        )}
      </div>
    );
  }
}

export default ImageUpload;
